import React, { useState, useMemo } from "react";

import { getRandomId } from "../utils";
import { validateText } from "./utils";

import useComponentVisible from "../../../../hooks/useComponentVisible";
import logger from "../../../../utils/LoggerFrontend";

import { SidePanel, Tooltip } from "../Components";
import { ButtonPrimary, ButtonOutlined } from "../Components/Buttons";

import * as sc from "./styles";

const TextEditor = ({
  bannedCharacters,
  editable,
  label,
  maxLength = 30,
  name,
  postNumber,
  updateChannelData,
  updatePost,
  value
}) => {
  const [text, setText] = useState(value);

  const {
    ref,
    isComponentVisible: open,
    setIsComponentVisible: setOpen
  } = useComponentVisible(false);

  function onEdit() {
    if (editable) {
      setOpen(true);
    }
  }

  function onChange(e) {
    e.preventDefault();
    e.stopPropagation();

    setText(e.target.value);
  }

  function onSave() {
    const result = validateText({ text, bannedCharacters });

    if (!result.valid) {
      logger.log("TextEditor:onSave", result.error, result);
      setOpen(false);
      return;
    }

    updatePost({ [name]: text });

    // Fallback to keep channelData updated
    if (postNumber === 1) {
      updateChannelData({ key: name, value: text });
    }

    setOpen(false);
  }

  const tooltipId = useMemo(() => getRandomId(), []);

  return (
    <sc.TextEditor>
      <sc.Text onClick={onEdit} data-tip="" data-for={tooltipId}>
        {value || label}
      </sc.Text>

      {editable && (
        <Tooltip
          id={tooltipId}
          effect="solid"
          place="top"
          backgroundColor="#1c1928"
          offset={{ top: -5 }}
        >
          {label}
        </Tooltip>
      )}

      <SidePanel active={open} side="left" height="auto" offset={6}>
        <sc.Editor ref={ref}>
          <sc.LabelContainer>
            <sc.Label htmlFor={name}>{label}</sc.Label>
            <sc.MaxLength>{`${text?.length || 0}/${maxLength}`}</sc.MaxLength>
          </sc.LabelContainer>

          <sc.Input
            name={name}
            type="text"
            value={text}
            onChange={onChange}
            maxLength={maxLength}
          />

          <sc.Actions>
            <ButtonPrimary onClick={onSave} small>
              <sc.IconChecked fill="#1e22ff" />
            </ButtonPrimary>

            <ButtonOutlined onClick={() => setOpen(false)} small>
              <sc.IconClear />
            </ButtonOutlined>
          </sc.Actions>
        </sc.Editor>
      </SidePanel>
    </sc.TextEditor>
  );
};

export default TextEditor;
